import { useMemo } from 'react';
import { create } from 'zustand';
const usePurchasePopupAnchorStore = create(() => ({}));
export function setPurchasePopupAnchor(anchorElement) {
    usePurchasePopupAnchorStore.setState({ anchorElement });
}
export function usePurchasePopupAnchorElementRef() {
    const anchorElement = usePurchasePopupAnchorStore((s) => s.anchorElement);
    return useMemo(() => {
        return anchorElement ? { current: anchorElement } : undefined;
    }, [anchorElement]);
}
